import styled from "styled-components";

export const StyledLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledFeedbackform = styled.form`
  max-width: 100%;
  margin-top: 25px;

  @media (min-width: 768px) {
    margin-top: 35px;
  }
`;

export const StyledFormGroup = styled.div`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const StyledFeedbackFormAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 24px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 24px;
  }
`;

export const StyledActionText = styled.span<{
  isError?: boolean | null;
  isSuccess?: boolean | null;
}>`
  display: inline-block;
  margin-top: 25px;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.26;
  color: ${({ isSuccess, isError }) =>
    isSuccess ? "#00B007" : isError ? "#B00000" : "#222"};

  @media (min-width: 768px) {
    margin-top: 0;
    margin-left: 10px;
  }
`;
